import axios from "axios";

export const loadAllQuotesAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&siteId=${
        payload?.appliedFilters?.siteId ?? ""
      }&countries=[${payload.selectedCountries}]&status=[${
        payload?.appliedFilters?.status ?? payload?.statusFilters
      }]&admins=[${payload?.salesman}]&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&orderColumn=${payload.sort ? payload.sort.column : "id"}&search=${
        payload.search ?? ""
      }&dependancies=${payload?.dependancies}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleQuoteAPI = (payload) => {
  return axios
    .get(`/quotes/${payload.quoteId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
